<template>
  <b-container class="py-3">
    <b-form-group label="Raw data">
      <b-form-textarea rows="10" v-model="rawData" class="text-monospace" size="sm"></b-form-textarea>
    </b-form-group>

    <div class="my-3">
      <b-button variant="outline-primary" @click="editorData = rawData">To CKEditor</b-button>
    </div>

    <b-form-group label="CKEditor" class="mb-3">
      <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
    </b-form-group>

    <b-form-group label="Source">
      <b-form-textarea rows="5" readonly :value="editorData" class="text-monospace" size="sm"></b-form-textarea>
    </b-form-group>
  </b-container>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as utils from "@/service/util";


  @Component
  export default class TestCKEditor extends BaseComponent {

    editor = null;
    editorConfig = {
      toolbar: [
        "heading", "|",
        "undo", "redo", "|",
        "bold", "italic", "underline", "strikethrough", "fontFamily", "fontSize", "fontColor", "fontBackgroundColor", "|",
        "bulletedList", "numberedList", "|", "indent", "outdent", "|",
        "blockquote", "link", "code", "horizontalLine", "|",
        "removeFormat", "sourceEditing"
      ],
    };

    editorData = "";
    rawData = "<p>Kính gửi Anh/Chị: {PARTICIPANT_NAME}</p>\n\n<p>Bạn được mời tham gia phiên họp trực tuyến\n<br />Chủ đề: <strong style=\"color: blue;\">{MEETING_NAME}</strong>\n<br />Thời gian: <span style=\"color:blue;\"><strong>{SCHEDULE}</strong></span>\n<br />Chủ trì: <span style=\"color:hsl(210, 75%, 60%);\"><strong>{HOST}</strong></span>\n<br />Thành phần: {PARTICIPANTS}\n</p>\n\n<script>alert(\"xss\")<\/script>\n\n<p>Tham gia họp\n<a href=\"{URL}\">{URL}</a><br />\n</p>\n<p>\nMã truy cập: {PASSCODE}\n</p>\n<p>\nNgười tạo: {CREATED_BY}\n</p>";

    async mounted() {
      this.editor = await utils.loadCkeditor();
      this.editorData = '';
    }

  }
</script>
